import * as React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import Header from "../components/Header";
import Details from "../components/Details";
import Hero from "../components/Hero";
import Service from "../components/Service";
import Footer from "../components/Footer";
import About from "../components/About";
import Team from "../components/Team";
import Contact from "../components/Contact";

const IndexPage = () => {
  const query = useStaticQuery(graphql`
    {
      allContentful00Seo {
        nodes {
          author
          description
          keywords
          robots
          url
          title
        }
      }
    }
  `);

  const local = {
    description: "We deliver smart, affordable legal solutions tailored to you. Segun Owoeye LP is a trusted Nigerian firm with 15+ years’ expertise. Specialists in corporate, property, family, employment, and Intellectual Property law.",
    title: "Segun Owoeye LP - Your trusted legal partners",
    robot: "index, follow",
    keywords: "law firm, solicitors, lawyers, barristers",
    url: "https://segunowoeyelp.com/"
  }

  const data = query.allContentful00Seo.nodes[0];

  return (
    <main>
      <Helmet htmlAttributes={{ lang: "en" }}>
        <meta charSet="utf-8" />
        <meta name="description" content={local.description} />
        <meta name="keywords" content={local.keywords} />
        <meta name="robots" content={local.robot} />
        <meta property="og:title" content={local.title} />
        <meta property="og:description" content={local.description} />
        <meta property="og:url" content={local.url} />
        {/* <meta property="og:image" content="Segun Owoeye LP" /> */}
        <meta name="author" content="Sunbeam Product Studio" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{data.title}</title>
      </Helmet>
      <Details />
      <Header />
      <Hero />
      <About />
      <Service />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
};

export default IndexPage;
